import { useCallback } from 'react';
import { useAppDispatch, useAppSelector } from '../hooks';
import {
  fetchTemplatesApiThunk,
  createTemplateApiThunk,
  updateTemplateApiThunk,
  resetAllApiStatus,
  setCurrentTemplate,
  clearAPIStatusMessages,
} from './templatesSlice';
import { RootState } from '..';
import {
  CreateAuditTemplateRequest,
  ListAuditTemplatesRequest,
  UpdateAuditTemplateRequest,
} from 'src/types/helios/AuditTemplate';
import { AuditTemplate } from '@amzn/gbsa-helios-typescript-client';

export const useTemplates = () => {
  const dispatch = useAppDispatch();

  const templatesList = useAppSelector(
    (state: RootState) => state.templates.templatesList,
  );
  const fetchTemplatesApiStatus = useAppSelector(
    (state: RootState) => state.templates.fetchTemplatesApiStatus,
  );
  const createTemplateApiStatus = useAppSelector(
    (state: RootState) => state.templates.createTemplateApiStatus,
  );
  const updateTemplateApiStatus = useAppSelector(
    (state: RootState) => state.templates.updateTemplateApiStatus,
  );

  const currentTemplate = useAppSelector(
    (state: RootState) => state.templates.currentTemplate,
  );

  const loadTemplatesList = useCallback(
    async (data: ListAuditTemplatesRequest) => {
      dispatch(fetchTemplatesApiThunk({ isActive: true, ...data }));
    },
    [dispatch],
  );

  const createTemplate = useCallback(
    async (data: CreateAuditTemplateRequest) => {
      dispatch(createTemplateApiThunk(data));
    },
    [dispatch],
  );

  const updateTemplate = useCallback(
    async (data: UpdateAuditTemplateRequest) => {
      dispatch(updateTemplateApiThunk(data));
    },
    [dispatch],
  );

  const resetApiStatus = useCallback(() => {
    dispatch(resetAllApiStatus());
  }, [dispatch]);

  const clearStatusMessages = useCallback(() => {
    dispatch(clearAPIStatusMessages());
  }, [dispatch]);

  const selectCurrentTemplate = useCallback(
    async (data?: AuditTemplate) => {
      dispatch(setCurrentTemplate(data));
    },
    [dispatch],
  );

  return {
    templatesList,
    fetchTemplatesApiStatus,
    createTemplateApiStatus,
    updateTemplateApiStatus,
    currentTemplate,
    selectCurrentTemplate,
    loadTemplatesList,
    createTemplate,
    updateTemplate,
    resetApiStatus,
    clearStatusMessages,
  };
};
